import { useAuth } from '../hooks/useAuth';

// Renders the analyst variant when the current user has analyst role, otherwise admin/viewer variant.
// Waits for auth to resolve before mounting either child — prevents the admin Dashboard from firing
// finance XHRs on the initial paint when the user is actually an analyst.
const RoleAwareDashboard = ({ admin, analyst }) => {
  const { isAnalyst, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center">
        <div className="font-body text-text-secondary">Loading…</div>
      </div>
    );
  }
  return isAnalyst ? analyst : admin;
};

export default RoleAwareDashboard;
